import React from 'react';
import styles from './PageLoader.module.scss';

interface PageLoaderProps {
    /** Optional custom message (defaults to generic spinner) */
    message?: string;
}

/**
 * Unified full-page loading spinner.
 * Used consistently across all pages for a polished loading experience.
 */
const PageLoader: React.FC<PageLoaderProps> = ({ message }) => {
    return (
        <div className={styles.loaderContainer}>
            <div className={styles.spinner} />
            {message && <span className={styles.message}>{message}</span>}
        </div>
    );
};

export default PageLoader;
